import {Helmet} from 'react-helmet-async';

const Head = () => <Helmet></Helmet>;

export default Head;
